export default __webpack_public_path__ + "static/media/light.fe513abd.svg";